const minuteMs = 60_000
const hourMs = 60 * minuteMs
export default {
	minimumDate: -62135596800000,
	system: {
		version: process.env.VUE_APP_VERSION!,
		patchNotesDismissDuration: 12 * hourMs,
		nowUpdateInterval: 10_000,
		isUnloadedCheckDelay: 300,
		reloadCooldown: minuteMs,
	},
	general: {
		queryDelay: 400,
		localQueryDelay: 200,
		fallbackCurrency: "DKK",
		prioritizedCurrencies: ["DKK", "EUR"],
		locationLanguages: ["da", "en", "de", "no"],
		defaultLocationLanguage: "da",
		showPayedUntilCutoff: 3 * 365,
		logNoneCriticalToAWS: false,
		offlineWaitTimeout: 5_000,
		updateOnNavigationTimeout: 10_000,
		routerGuardTimeOut: 15_000,
		mediaLoadTimeout: 30_000,
		noErrorLogEnvironments: ["Development", "Integration"],
		fallbackLogo: require("@/assets/placeholder/locationLogo.png")
	},
	errors: {
		publisherNotReady: "PublisherReadinessPolicy"
	},
	user: {
		minimumPasswordLength: 8
	},
	connections: {
		portalPath: process.env.VUE_APP_CONNECTIONS_PORTAL_PATH!,
		facebookAppId: process.env.VUE_APP_CONNECTIONS_FACEBOOK_APP_ID!,
		facebookSdkTimeout: 10_000,
		intercomAppId: process.env.VUE_APP_CONNECTIONS_INTERCOM_APP_ID!,
		globalSiteTagId: process.env.VUE_APP_CONNECTIONS_GLOBAL_SITE_TAG_ID!,
		zapierPath: process.env.VUE_APP_CONNECTIONS_ZAPIER_PATH!,
		errorLogPath: "https://errorlog.postofficesocial.com",
		errorLogEnvironment: process.env.VUE_APP_ERROR_LOG_ENVIRONMENT!,
		stripePublishableKey: process.env.VUE_APP_CONNECTIONS_STRIPE_KEY!,
		stripePricingTableId: process.env.VUE_APP_CONNECTIONS_STRIPE_PRICETABLE!,
		stripeCustomerPortalPath: process.env.VUE_APP_CONNECTIONS_STRIPE_CUSTOMERPORTAL!
	},
	localization: {
		default: process.env.VUE_APP_LOCALIZATION_DEFAULT! as string,
		fallback: "en",
		names: {"en": "English","da": "Dansk","de": "Deutsch"},
		hiddenLanguages: [] as string[]
	},
	documents: {
		termsVersion: "TermsOfUse:v1"
	},
	navigation: {
		navigationListMaxItems: 10
	},
	files: {
		statusUpdateInterval: 10_000
	},
	signUp: {
		redirectKey: "signUpRedirect"
	},
	deals: {
		customers: {
			list: {
				pageSize: 20
			}
		},
		orders: {
			anonymizedName: "Anonymized",
			list: {
				updateInterval: 10_000,
				pageSize: 20
			}
		},
		list: {
			pageSize: 10,
			updateInterval: 20_000
		},
		blackListedPlaceholders: ["ProductDescription"],
		textLimits: {
			liveConfirmation: 500
		},
		subscriptions: {
			enabledOnDeals: false,
			enabledOnLive: false
		}
	},
	live: {
		goLiveUrl: "https://www.facebook.com/live/producer/?target_id=$id"
	},
	content: {
		pageSize: 20,
		urlPreview: {
			cleanupInterval: minuteMs * 30,
			cacheDuration: hourMs * 24
		}
	},
	calendar: {
		loadChunkWeeks: 2,
		loadInitialWeek: -1,
		loadMinimumInterval: 100,
		limitPastWeeks: 100,
		limitFutureWeeks: 100,
		updateInterval: 15_000,
		errorDelay: 1_000,
		publishSuccessCloseDelay: 2_500,
		expireInterval: 6 * hourMs
	},
	post: {
		defaultPublishTime: 12,
		dateMinuteInterval: 5,
		pastDateBuffer: 5 * minuteMs,
		preapprovedTimeout: 15 * minuteMs,
		postingSoonLimit: 15_000,
		invalidLinks: [/^https:\/\/(?:www.)?facebook.com\/events/],
		deals: {
			defaultSaleToDurationDays: 4,
			triggerPhrases: {
				maximumCount: 4,
				minimumLength: 3
			}
		},
		live: {
			defaultMatchEndDuration: hourMs,
			matchEndDurationOptions: [
				15 * minuteMs,
				30 * minuteMs,
				45 * minuteMs,
				hourMs,
				2 * hourMs,
				3 * hourMs,
				4 * hourMs,
				5 * hourMs,
				6 * hourMs,
				7 * hourMs,
				8 * hourMs,
				9 * hourMs,
				10 * hourMs],
		},
		carousel: {
			limits: {
				titleLength: 35,
				descriptionLength: 30
			}
		}
	},
	publishers: {
		canAddPublisher: true,
		secretKeyMinimumLength: 20,
		builtIn: {
			Facebook: 1,
			Instagram: 2
		}
	},
	insights: {
		pageSize: 20,
		standardPeriods: [7, 28, 84],
		maxPeriod: 93
	},
	mediaEditor: {
		maxFonts: 20,
		maxStickers: 100,
		maxColors: 20,
		fontSizeOptions: [1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 24, 26, 28, 30, 32, 40]
	}
}
